import React from "react";
import TicketsTransactions from "../modules/Transactions/tickets-transactions/TicketsTransactions";

export default function TicketsTransactionsPage() {
  return <TicketsTransactions />;
}
